/** Telas com campos obrigatórios configuráveis na API Pessoa (db_pessoa.tela). */
export enum TelaPessoaEnum {
    Pessoa = 1,
    Vendedor = 2,
}
